import {
  UPDATEFEEMANAGEMENTLIST_SUCCESS,
  UPDATEFEEMANAGEMENTLIST_FAILED,
  RESET_UPDATEFEEMANAGEMENTLIST,
  LOADING_UPDATEFEEMANAGEMENTLIST,
  NETWORK_ERROR_UPDATEFEEMANAGEMENTLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATEFEEMANAGEMENTLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATEFEEMANAGEMENTLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATEFEEMANAGEMENTLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATEFEEMANAGEMENTLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATEFEEMANAGEMENTLIST:
      return (state = initialState);
    default:
      return state;
  }
};
